import React from 'react';
import MenuItem from "../../atoms/MenuItem/MenuItem"

export default function ListMovil({menuItems, wordPressUrl, styleCss, classEle}) {
  return (
    <ul css={styleCss}>
      {
        menuItems &&
        menuItems.map((menuItem) => (
          menuItem?.parentId === null ? (
            <MenuItem
              key={menuItem.id}
              menuItem={menuItem}
              wordPressUrl={wordPressUrl}
            />
          ) : null
        )
        )}
        {/* <MenuItem
            key={101}
            menuItem={{
              id: "cG9zdDoxOTU5N1==",
              label: "Blog",
              url: "https://blog.armandoparedes.com/",
              title: null,
              target: null,
              parentId: "",
              childItems: {
                edges: []
              }
            }}
            wordPressUrl={wordPressUrl}
          />
          <MenuItem
            key={102}
            menuItem={{
              id: "cG9zdDoxOTU5N2==",
              label: "Contacto",
              url: "/#contacto-home",
              title: null,
              target: null,
              parentId: "",
              childItems: {
                edges: []
              }
            }}
            wordPressUrl={wordPressUrl}
          /> */}
    </ul>
  );
}

ListMovil.defaultProps = {
  menuItems: null,
  wordPressUrl: '',
  styleCss: {}
}